import { getSearchParams } from './getSearchParams';
export const isDropshippingFlow = () => {
  const {
    referralAdditionalInfo
  } = getSearchParams();
  return referralAdditionalInfo === 'add-domain-connect-intent-dropshipping' || referralAdditionalInfo === 'add-domain-purchase-intent-dropshipping';
};
//# sourceMappingURL=isDropshippingFlow.js.map